import { Expose, Transform } from "class-transformer";

export class CrmContactDto {
  @Expose()
  department!: string;

  @Expose()
  salutation!: string;

  @Expose()
  firstname!: string;

  @Expose()
  lastname!: string;

  @Expose()
  jobtitle!: string;

  @Expose()
  @Transform(({ value, obj }) => value ?? obj["telephone1"])
  telephone!: string;

  @Expose()
  @Transform(({ value, obj }) => value ?? obj["mobilephone"])
  mobilePhone!: string;

  @Expose()
  @Transform(({ value, obj }) => value ?? obj["emailaddress1"])
  email!: string;
}
